import React from 'react';
import './App.scss';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { StateProvider } from './state/store';

import { ResponsivityProvider } from '@scholastic/volume-react';

import StatsReport from './Components/StatsReport/StatsReport';
import Home from './Components/Home/Home';
import ReportCharts from './Components/ReportCharts/ReportCharts';
import CounterReports from './Components/CounterReports/CounterReports';
import MonthlyReports from './Components/MonthlyReports/MonthlyReports';
import StatsHelp from './Components/Help/StatsHelp';
import Login from './Components/Login/Login';
import PrivateRoute from './helper/PrivateRoute';
import GroupLevelReports from './Components/GroupLevelReports/GroupLevelReports';
import UserGroupReport from './Components/OnScreenReport/UserGroupReport/UserGroupReport';
import OverallSummaryReport from './Components/OnScreenReport/OverallSummaryReport/OverallSummaryReport';
import IndividualSiteReports from './Components/OnScreenReport/IndividualSiteReports/IndividualSiteReports';

const App = () => {
  document.title = 'Scholastic Statistical Reporting';

  return (
    <StateProvider>
      <ResponsivityProvider>
        <Router>
          <Switch>
            <PrivateRoute path="/report-charts" component={ReportCharts}></PrivateRoute>
            <PrivateRoute path="/counter-reports" component={CounterReports}></PrivateRoute>
            <PrivateRoute path="/stat-report" component={StatsReport}></PrivateRoute>
            <PrivateRoute path="/monthly-reports" component={MonthlyReports}></PrivateRoute>
            <PrivateRoute path="/group-level-reports" component={GroupLevelReports}></PrivateRoute>
            <PrivateRoute
              path="/overall-summary-report"
              component={OverallSummaryReport}
            ></PrivateRoute>
            <PrivateRoute path="/user-group-report" component={UserGroupReport}></PrivateRoute>
            <PrivateRoute
              path="/individual-site-reports"
              component={IndividualSiteReports}
            ></PrivateRoute>
            <PrivateRoute path="/stats-help" component={StatsHelp}></PrivateRoute>
            <PrivateRoute path="/home" component={Home}></PrivateRoute>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/">
              <Login />
            </Route>
          </Switch>
        </Router>
      </ResponsivityProvider>
    </StateProvider>
  );
};

export default App;
